import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {scroller} from "react-scroll";
import {withStyles} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";
import {navigationSelector, next, back} from "../../ducks/navigation";
import {getResults} from "../../ducks/results";

import styles from "./navigation.module.scss";

const materialStyles = {
  button: {
    "padding": `12px 40px`,
    "background": `#d3463d`,
    "color": `#fff`,
    "fontSize": `16px`,
    "fontWeight": `normal`,
    "&:hover": {
      background: `#d3463d`,
      opacity: `.8`
    }
  },
  backButton: {
    "padding": `12px 40px`,
    "color": `#d3463d`,
    "fontSize": `16px`,
    "fontWeight": `normal`,
    "background": `none`,
    "border": `1px solid #d3463d`,
    "&:hover": {
      background: `none`,
      opacity: `.8`
    }
  }
};

function Navigation(props) {
  const {classes, navigation} = props;
  const firstStep = navigation === 0;
  const lastStep = navigation === 3;
  const handleBackClick = () => {
    props.back();
    scroller.scrollTo(`cards-scroll-element`, {
      offset: -80,
      smooth: true
    });
  };
  const handleNextClick = () => {
    props.next();
    scroller.scrollTo(`cards-scroll-element`, {
      offset: -80,
      smooth: true
    });
  };
  const handleGetResults = () => {
    props.getResults();
    scroller.scrollTo(`header-scroll-element`, {
      offset: -80,
      smooth: true
    });
  };
  return (
    <Grid container justify="center" className={styles.root}>
      <Hidden mdUp>
        <Grid item xs={12} className={styles.buttons}>
          {/* only mobile */}
          {!firstStep && (
            <Button
              classes={{root: classes.backButton}}
              onClick={handleBackClick}
            >
              Назад
            </Button>
          )}
          <Button
            onClick={lastStep ? handleGetResults : handleNextClick}
            classes={{root: classes.button}}
          >
            {lastStep ? `Подобрать` : `Далее`}
          </Button>
        </Grid>
      </Hidden>
      <Hidden smDown>
        <Grid item>
          {/* only desktop */}
          <Button
            type="submit"
            classes={{
              root: classes.button
            }}
          >
            Подобрать подарок
          </Button>
        </Grid>
      </Hidden>
    </Grid>
  );
}

Navigation.propTypes = {
  classes: PropTypes.object,
  navigation: PropTypes.number,
  next: PropTypes.func,
  back: PropTypes.func,
  getResults: PropTypes.func
};

export default withStyles(materialStyles)(
  connect(
    (state) => ({
      navigation: navigationSelector(state)
    }),
    {
      back,
      next,
      getResults
    }
  )(Navigation)
);
